<div [formGroup]="campaignForm" class="has-validation">
  <label class="form-label">
    {{ 'field.country' | translate }}
  </label>
  <select class="form-select" id="country" formControlName="country" [ngClass]="{ 'is-invalid': campaignForm.get('country')?.invalid}">
    <option *ngFor="let country of countries" [value]="country.code">{{ getTranslatedCountryName(country.code) }}</option>
    <option value="---" disabled>---</option>
    <option *ngFor="let country of alphabetizedCountries" [value]="country.code">{{ getTranslatedCountryName(country.code) }}</option>
  </select>
  <div class="invalid-feedback" translate="field.required"></div>
</div>
